import axios from "axios";
import * as types from "../mutation-types";
import api from "../../api/api";

export const state = {
  listItemsPerPage: [10, 25, 50, 100],
  sort: ["ASC", "DESC"],
  foots: [],
  divisions: [],
  positions: [],
  jobTitle: [],
  japaneseLevel: [],
  jobLevel: [],
  gender: [1, 2], // 1: male, 2: female
  workType: [],
  workShift: [],
  companies: [],
  rank: [1, 2, 3], // 1: "1", 2: "2", 3: "3",
  approvalStatus: [1, 2, 3], // 1: New, 2: Approved, 3: Rejected
  developDivisions: [],
  parentDevelopDivistions: [],
  qualityDivisions: [],
  contracts: [],
  mustSubmit: false,
  skillLv2: [],
  footDivision: []
};

// getters
export const getters = {
  listItemsPerPage: state => state.listItemsPerPage,
  sort: state => state.sort,
  foots: state => state.foots,
  divisions: state => state.divisions,
  positions: state => state.positions,
  jobTitle: state => state.jobTitle,
  japaneseLevel: state => state.japaneseLevel,
  jobLevel: state => state.jobLevel,
  gender: state => state.gender,
  workType: state => state.workType,
  workShift: state => state.workShift,
  companies: state => state.companies,
  rank: state => state.rank,
  approvalStatus: state => state.approvalStatus,
  developDivisions: state => state.developDivisions,
  parentDevelopDivistions: state => state.parentDevelopDivistions,
  qualityDivisions: state => state.qualityDivisions,
  mustSubmit: state => state.mustSubmit,
  contracts: state => state.contracts,
  skillLv2: state => state.skillLv2,
  footDivision: state => state.footDivision,
};

// mutations
export const mutations = {
  [types.COMMONS.FOOTS](state, foots) {
    state.foots = foots;
  },
  [types.COMMONS.DIVISIONS](state, divisions) {
    state.divisions = divisions;
  },
  [types.COMMONS.POSITIONS](state, positions) {
    state.positions = positions;
  },
  [types.COMMONS.JOBTITLE](state, jobTitle) {
    state.jobTitle = jobTitle;
  },
  [types.COMMONS.WORKTYPE](state, workType) {
    state.workType = workType;
  },
  [types.COMMONS.WORKSHIFT](state, workShift) {
    state.workShift = workShift;
  },
  [types.COMMONS.COMPANIES](state, companies) {
    state.companies = companies;
  },
  [types.COMMONS.LEVELS](state, levels) {
    state.jobLevel = levels;
  },
  [types.COMMONS.CERTIFICATES](state, certificates) {
    state.japaneseLevel = certificates;
  },
  [types.COMMONS.DEVELOP_DIVISIONS](state, developDivisions) {
    state.developDivisions = developDivisions;
  },
  [types.COMMONS.PARENT_DEVELOP_DIVISIONS](state, parentDevelopDivistions) {
    state.parentDevelopDivistions = parentDevelopDivistions;
  },
  [types.COMMONS.QUALITY_DIVISIONS](state, qualityDivisions) {
    state.qualityDivisions = qualityDivisions;
  },
  [types.COMMONS.PARENT_DEVELOP_DIVISIONS](state, parentDevelopDivistions) {
    state.parentDevelopDivistions = parentDevelopDivistions;
  },
  [types.COMMONS.CONTRACTS](state, contracts) {
    state.contracts = contracts;
  },
  [types.COMMONS.MUST_SUBMIT](state, mustSubmit) {
    state.mustSubmit = mustSubmit;
  },
  [types.COMMONS.SKILL_LV2](state, skillLv2) {
    state.skillLv2 = skillLv2;
  },
  [types.COMMONS.FOOT_DIVISION](state, footDivision) {
    state.footDivision = footDivision;
  },


};

// actions
export const actions = {
  async getCommonsData({ commit }) {
    if (
      state.foots.length === 0 ||
      state.divisions.length === 0 ||
      state.positions.length === 0 ||
      state.jobTitle.length === 0 ||
      state.companies.length === 0
    ) {
      const response = await axios.get(api.LIST_COMMON);
      commit(types.COMMONS.FOOTS, response.data.foots);
      commit(types.COMMONS.DIVISIONS, response.data.divisions);
      commit(types.COMMONS.POSITIONS, response.data.positions);
      commit(types.COMMONS.JOBTITLE, response.data.jobTitle);
      commit(types.COMMONS.WORKTYPE, response.data.workType);
      commit(types.COMMONS.WORKSHIFT, response.data.workShift);
      commit(types.COMMONS.COMPANIES, response.data.companies);
      commit(types.COMMONS.CERTIFICATES, response.data.certificates);
      commit(types.COMMONS.DEVELOP_DIVISIONS, response.data.developDivisions);
      commit(types.COMMONS.PARENT_DEVELOP_DIVISIONS, response.data.parentDevelopDivistions);
      commit(types.COMMONS.QUALITY_DIVISIONS, response.data.qualityDivisions);
      commit(types.COMMONS.CONTRACTS, response.data.contracts);
      commit(types.COMMONS.MUST_SUBMIT, response.data.mustSubmit);
      commit(types.COMMONS.SKILL_LV2, response.data.skillLv2);
    }
  },

  async getJobLevel({ commit }) {
    const response = await axios.get(api.LIST_COMMON);
    commit(types.COMMONS.LEVELS, response.data.levels);
  },
  async getDivisionByFoot({ commit }, footCode) {
    const response = await axios.get(api.FOOT_DIVISION, {
      params: {
        footCode: footCode
      }
    });
    commit(types.COMMONS.FOOT_DIVISION, response.data);
  },
};
